module.exports = __webpack_public_path__ + "img/whatsapp-info2.b5e6d434.png";